module.exports = __webpack_public_path__ + "static/media/摄图网_7.302c6f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_7.png
// module id = 1711
// module chunks = 0